import { useMemo, useState } from 'react'
import { SIMULATION_CASES, getSimulationCaseById } from '../simulation/cases'

export default function useSimulationMode() {
  const enabled = String(import.meta.env.VITE_ENABLE_SIMULATION_MODE || '').toLowerCase() === 'true'
  const [selectedCaseId, setSelectedCaseId] = useState(SIMULATION_CASES[0]?.meta?.caseId || '')

  const selectedCase = useMemo(() => getSimulationCaseById(selectedCaseId), [selectedCaseId])

  return {
    simulationEnabled: enabled,
    simulationCases: SIMULATION_CASES,
    selectedCaseId,
    setSelectedCaseId,
    selectedCase
  }
}
